<template>
  <div>
    <!-- <h1>This is Qustions 2</h1> -->
    <div v-if="session.startup_application" :class="{'opacity-50 cursor-not-allowed': (inProgress ||(session.startup_application.status!='0' && session.startup_application.status!='11' || !isLeader))}">
      <h1 class="text-bold text-blue mb-5">
        {{ $t("form.formInnoviation") }}
      </h1>
      <h2 class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b" v-if="session.session_name">
        {{ session.session_name.label }}
      </h2>
      <div v-if="isSubmitted && errors == null" class="alert alert-success bg-green-light text-sm border border-green text-green px-4 py-3 rounded relative mb-4">
        <p class="mb-0">
          <strong class="font-bold">{{ $t("form.submitted") }}</strong>
        </p>
      </div>
      <div v-if="innovationsFormApp && innovationsFormApp.started && !innovationsFormApp.complited" class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4" role="alert">
        <p class="mb-0">
          <strong class="font-bold">{{ $t("form.infinsh") }}</strong>

        </p>
      </div>

      <div v-if="errors" class="bg-red-lighter border border-red-light text-sm text-red-dark px-4 py-3 rounded relative mb-4" role="alert">
        <p class="mb-0">
          <strong class="font-bold">{{ $t("form.correctErrors") }}</strong
          >
        </p>
        <!--<ul class="error-messages block sm:inline text-left p-0 list-reset" v-if="errors.length > 0">
                    <li v-for="error in errors" v-bind:key="error.field">
                        <span v-if="error.field">
                  {{ $t('form.'+error.field) }}
                  <span v-if="error.message">: {{ $t(error.message) }}</span>
                        </span>
                        <span v-else-if="error.message">{{ $t(error.message) }}</span>
                    </li>
                </ul>-->
      </div>

      <form
              name="formInnovation"
              v-on:submit.prevent="innovationsFormSaveDraft()"
              v-if="innovationsFormApp"
      >
        <div v-for="(q, index) in innovationsFormApp.questions" :key="'A'+index">
          <div v-if="q.category_id === null" >
            <q-form
                    :question="q"
                    :showError="showError"
                    :responses="responses"
                    :started="innovationsFormApp.started"
                    :disabled="session.startup_application.status!='0' && session.startup_application.status!='11'"
                    @update-disabled="updateDisabled"
                    @governorate="governoratechange"
                    :delegation="delegation"
            ></q-form>
          </div>
        </div>

        <div v-for="(cat, index) in innovationsFormApp.categories" :key="'C'+index" >
          <h2 class="text-red text-lg text-bold mb-5 pb-2 py-6 border-red-light border-b">
            {{cat.name}}
          </h2>
          <div v-for="(q, index) in innovationsFormApp.questions" :key="'B'+index">
            <div v-if="q.category_id === cat.id">

              <q-form
                      :question="q"
                      :showError="showError"
                      :responses="responses"
                      :started="innovationsFormApp.started"
                      :disabled="session.startup_application.status!='0' && session.startup_application.status!='11'"
                      @update-disabled="updateDisabled"
                      @governorate="governoratechange"
                      :delegation="delegation"
              ></q-form>
            </div>
          </div>
        </div>
        <div
                class="flex items-center justify-end w-auto bg-white shadow-box mt-4 sm:mt-8 p-4 sm:p-8 pb-2 -mx-3"
                :class="{'opacity-50 cursor-not-allowed':this.inProgress}"
        >
          <sp-button
                  theme="outline-blue"
                  space="small"
                  :disabled="session.startup_application.status!='0' && session.startup_application.status!='11' || inProgress || !isLeader"
                  class="btn btn-lg btn-primary"
                  type="submit"
          >{{ $t("form.saveDraft")}}</sp-button
          >
          <sp-button
                  theme="blue"
                  space="small"
                  @click="preSave"
                  :disabled="session.startup_application.status!='0' && session.startup_application.status!='11' || inProgress || !isLeader"
                  class=""
                  type="submit"
          >{{ $t("form.previous")}}</sp-button>
          <sp-button
                  theme="blue"
                  space="small"
                  @click="nextSave"
                  :disabled="session.startup_application.status!='0' && session.startup_application.status!='11' || inProgress || !isLeader"
                  class=""
                  type="submit"
          >
            {{ $t("form.next")}}</sp-button>
        </div>
      </form>
    </div>
  </div>
</template>

<style>
  .border-rr:after {
    content: '';
    position: absolute;
    top: 0;
    right: -12px;
    width: 2px;
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(210, 216, 224, 0), rgba(210, 216, 224, 0.28), rgba(210, 216, 224, 0.78), rgba(210, 216, 224, 0));
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  @media screen and (max-width: 992px) {
    .border-rr:after {
      display: none;
    }
  }
</style>

<script>
    import {
        mapGetters,
        mapState
    } from "vuex";
    import {
        Innovations_FORM_GET,
        Innovations_FORM_SAVE_DRAFT
    } from "@/store/actions.type";
    import QForm from "@/components/Candidat/QForm.vue";
    import Tips from "@/components/spKit/Tips.vue";
    import Link from "@/components/spKit/Link.vue";
    import ButtonVue from "../../components/spKit/Button.vue";
    import { SET_Innovations_FORM } from "@/store/mutations.type";
    export default {
        name: "formInnovations",
        data() {
            return {
                inProgress: false,
                responses: [],
                isSubmitted: false,
                showError:false,
                isLeader: true,
                delegation:null,
                innovationsFormApp: null
            };
        },
        components: {
            "sp-link": Link,
            "q-form": QForm,
            "sp-tips": Tips,
            "sp-button": ButtonVue
        },
        methods: {
            governoratechange(data){
                this.delegation=data;
            },
            updateDisabled(val) {
                this.inProgress = val;
            },
            nextSave() {
                this.inProgress = true;
                let form = this.getForm();
                this.$store.dispatch(Innovations_FORM_SAVE_DRAFT, form)
                    .then(() => {
                        this.isSubmitted = true;
                        this.inProgress = false;
                        this.showError = true;
                        window.scrollTo(0, 0);
                        this.$router.push({
                            name: "team-edit",
                            params: {
                              team_id: this.session.user_auth.id,app_id: this.session.startup_application.id
                            }
                        });

                    })
                    .catch(() => {
                        this.inProgress = false;
                        window.scrollTo(0, 0);
                    });

            },
            preSave() {
                this.inProgress = true;
                let form = this.getForm();
                this.$store.dispatch(Innovations_FORM_SAVE_DRAFT, form)
                    .then(() => {
                        this.isSubmitted = true;
                        this.inProgress = false;
                        this.showError = true;
                        window.scrollTo(0, 0);
                        this.$router.push({
                            name: "FormCriteria",
                            params: {
                                app_id: this.session.startup_application.id
                            }
                        });

                    })
                    .catch(() => {
                        window.scrollTo(0, 0);
                        this.inProgress = false;

                    });;
            },
            innovationsFormSaveDraft() {
                this.$Progress.start();
                let app_id = this.session.startup_application.id;
                this.inProgress = true;
                let form = this.getForm();
                this.isSubmitted = false;
                this.$store.dispatch(Innovations_FORM_SAVE_DRAFT, form).then(() => {
                    window.scrollTo(0, 0);
                    this.isSubmitted = true;
                    this.inProgress = false;
                    this.showError = true;

                });


            },
            getForm() {
                let app_id = this.session.startup_application.id;
                this.inProgress = true;
                let finalResponses = [];
                Array.prototype.forEach.call(this.responses, final => {
                    if (Array.isArray(final.content) && final.content.length === 0) final.content = "";
                    if (final.content != null) {
                        finalResponses.push(final);
                    }
                });
                let form = {
                    id: app_id,
                    responses: finalResponses
                };
                return form;
            }
        },
        watch: {
            errors() {
                this.$Progress.fail()
            },
            innovationsForm(val) {
              this.innovationsFormApp = val;
            }
        },
        mounted() {
          this.$Progress.start();
            this.$store.dispatch(Innovations_FORM_GET, this.$route.params.app_id).then((data) => {
              this.innovationsFormApp = data.data.form;
              if (this.session &&
                this.session.startup_application &&
                this.session.user_auth &&
                this.session.startup_application.user_id != this.session.user_auth.id
              ) {
                this.isLeader = false;
              }
              this.$store.commit(SET_Innovations_FORM, data.data);
              this.showError = true;
              this.$Progress.finish();
            })
            .catch((error) => {
              this.$router.push({ name: "home" });
            });
        },
        computed: {
            ...mapGetters(["session", "innovationsForm"]),
            ...mapState({
                errors: state => state.session.errors
            })
        }
    };
</script>
